
import request from '@/utils/request'

//注册验证邮箱
export function registerCheckEmail (data) {
  return request({
    url: "/api-sp/sp/userFront/checkEmail",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//发送邮箱注册验证码
export function sendRegisterEmail (data) {
  return request({
    url: "/api-sp/sp/userFront/sendRegisterEmail",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//验证邮箱注册验证码
export function checkRegisterEmail (data) {
  return request({
    url: "/api-sp/sp/userFront/checkRegisterEmail",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//获取国家地区
export function getCountry (data) {
  return request({
    url: "/api-sp/sp/userFront/getCountry",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//获取一级行政区
export function getState (data) {
  return request({
    url: "/api-sp/sp/userFront/getStates",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}


//用gsm 国家id获取一级行政区（因注册时获取一级行政区所用国家id未so表中id，而所提交id为gsm国家表中id）
export function getStatesByGSMCountryId (data) {
  return request({
    url: "/api-sp/sp/userFront/getStatesByGSMCountryId",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}





//获取二级行政区
export function getCity (data) {
  return request({
    url: "/api-sp/sp/userFront/getCitys",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}



//获取电话国家区号
export function getAreaCode (data) {
  return request({
    url: "/api-sp/sp/userFront/getAreaCode",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//获取行业
export function getIndustry (data) {
  return request({
    url: "/api-sp/sp/userFront/getIndustry",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//验证公司唯一性
export function checkCompany (data) {
  return request({
    url: "/api-sp/sp/userFront/checkCompanyName",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//获取公司信息
export function getCorpByName (data) {
  return request({
    url: "/api-sp/sp/userFront/getCorpByName",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//注册
export function register (data) {
  return request({
    url: "/api-sp/sp/userFront/register",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//登录
export function login (data) {
  return request({
    url: "/api-auth/spoauth/user/sptoken",
    method: 'post',
    data: data,
    headers: {
      'client_id': 'sangfor',
      'client_secret': 'webApp',
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
  })
}

//获取用户信息
export function getUserInfo (data) {
  return request({
    url: "/api-sp/sp/user/getUserInfo",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//忘记密码发送验证码
export function sendForgetPwdEmail (data) {
  return request({
    url: "/api-sp/sp/userFront/sendForgetPwdEmail",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//忘记密码发送验证码
export function checkForgetEmail (data) {
  return request({
    url: "/api-sp/sp/userFront/checkForgetEmail",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//修改密码
export function updatePassword (data) {
  return request({
    url: "/api-sp/sp/userFront/updatePassword",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//忘记密码验证邮箱是否被注册
export function checkHavetEmail (data) {
  return request({
    url: "/api-sp/sp/userFront/checkHavetEmail",
    method: 'post',
    data: data,
    headers: {
      client_id: 'sangfor',
      client_secret: 'webApp',
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}

//退出登录
export function logout (data) {
  return request({
    url: "/api-auth/spoauth/remove/sptoken?token=" + data,
    method: 'post',
    headers: {
      'Content-Type': "application/json; charset=utf-8",
    },
  })
}